import styled from 'styled-components'

export const Label = styled.label`
font: normal normal 600 13px/15px;
font-family: 'Inter';
color:#5C5A5A;
`